'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useTranslations } from 'next-intl';
import { type MouseEvent } from 'react';
import { useState } from 'react';
import { FaFlag, FaHeart } from 'react-icons/fa6';
import { LISTINGS_TYPES_TO_ID } from '@/features/listing/constants/listing-constants';
import createListingBookmark from '@/features/listing/requests/create-listing-bookmark';
import deleteListingBookmark from '@/features/listing/requests/delete-listing-bookmark';
import { type Listing, type ListingType } from '@/features/listing/types/listing-types';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { useRouter } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import styles from './listings-detail-actions.module.scss';
interface ListingDetailActionsProps {
  isBookmarked: boolean;
  listingType: ListingType;
  listingId: Listing['id'];
  onReportClick: () => void;
}
export default function ListingDetailActions(props) {
  const $ = _c(34);
  const {
    isBookmarked,
    listingId,
    listingType,
    onReportClick
  } = props;
  const router = useRouter();
  const actionsTranslation = useTranslations("global.actions");
  const bookmarkAppFlyerLink = useAppFlyerLink("mobile", "mobileListingBookmark", ROUTER_LINKS.phoneAuth);
  const reportAppFlyerLink = useAppFlyerLink("mobile", "mobileListingReport", ROUTER_LINKS.phoneAuth);
  const [isListingBookmarked, setIsListingBookmarked] = useState(isBookmarked);
  let t0;
  if ($[0] !== bookmarkAppFlyerLink || $[1] !== isListingBookmarked || $[2] !== listingId || $[3] !== listingType || $[4] !== router) {
    t0 = event => {
      event.stopPropagation();
      event.preventDefault();
      const loggedUser = getUserBearerCookie();
      if (loggedUser) {
        const currentListingTypeId = LISTINGS_TYPES_TO_ID[listingType];
        if (isListingBookmarked) {
          setIsListingBookmarked(false);
          deleteListingBookmark(listingId, currentListingTypeId).catch(_temp);
        } else {
          setIsListingBookmarked(true);
          createListingBookmark(listingId, currentListingTypeId).catch(_temp2);
        }
      } else {
        router.push(bookmarkAppFlyerLink);
      }
    };
    $[0] = bookmarkAppFlyerLink;
    $[1] = isListingBookmarked;
    $[2] = listingId;
    $[3] = listingType;
    $[4] = router;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const handleBookmarkClick = t0;
  let t1;
  if ($[6] !== onReportClick || $[7] !== reportAppFlyerLink || $[8] !== router) {
    t1 = () => {
      const loggedUser_0 = getUserBearerCookie();
      if (loggedUser_0) {
        onReportClick();
      } else {
        router.push(reportAppFlyerLink);
      }
    };
    $[6] = onReportClick;
    $[7] = reportAppFlyerLink;
    $[8] = router;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const handleReportClick = t1;
  const t2 = isListingBookmarked && styles.listingDetailActions_action__isBookmarked;
  let t3;
  if ($[10] !== t2) {
    t3 = cx(styles.listingDetailActions_action, t2);
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FaHeart className={styles.listingDetailActions_actionIcon} />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== actionsTranslation || $[14] !== isListingBookmarked) {
    t5 = isListingBookmarked ? actionsTranslation("saved") : actionsTranslation("save");
    $[13] = actionsTranslation;
    $[14] = isListingBookmarked;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className={styles.listingDetailActions_actionInner}>{t4}<p className={styles.listingDetailActions_text}>{t5}</p></div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== handleBookmarkClick || $[19] !== t3 || $[20] !== t6) {
    t7 = <button className={t3} aria-label="favorite" onClick={handleBookmarkClick}>{t6}</button>;
    $[18] = handleBookmarkClick;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cx(styles.listingDetailActions_action);
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FaFlag className={styles.listingDetailActions_actionIcon} />;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== actionsTranslation) {
    t10 = actionsTranslation("report");
    $[24] = actionsTranslation;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10) {
    t11 = <div className={styles.listingDetailActions_actionInner}>{t9}<p className={styles.listingDetailActions_text}>{t10}</p></div>;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== handleReportClick || $[29] !== t11) {
    t12 = <button className={t8} aria-label="report" onClick={handleReportClick}>{t11}</button>;
    $[28] = handleReportClick;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t7) {
    t13 = <div className={styles.listingDetailActions}>{t7}{t12}</div>;
    $[31] = t12;
    $[32] = t7;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}
function _temp2() {
  return null;
}
function _temp() {
  return null;
}